import { Injectable } from '@angular/core';
import { BaseProvider } from '../../providers/base-provider';
import { HeaderNotifier } from '../notifiers/header-notifier';
import { HeaderState } from '../states/header-state';

@Injectable({ providedIn: 'root' })
export class HeaderProvider extends BaseProvider<HeaderNotifier, HeaderState> {
  constructor() {
    super(HeaderNotifier);
  }
}
